import { useContext, useEffect, useState } from 'react';

import Card from '@/components/Card';
import FileUpload from './FileUpload';
import { GlobalContext } from '@/context';
import LoadingOverlay from '@/components/LoadingOverlay';
import StateIdInput from './StateIdInput';
import mmjCardService from '@/services/mmjCard.service';

const FILE_UPLOAD_STATES = ['va', 'ga'];
const TEXT_INPUT_STATES = ['pa', 'md'];
const SUPPORTED_STATES = [...FILE_UPLOAD_STATES, ...TEXT_INPUT_STATES];

const PatientDocumentUpload = () => {
  const {
    currentUser,
    currentPlatform: { uid: platformId },
  } = useContext(GlobalContext);

  const userState = currentUser.state ? currentUser.state.toLowerCase() : '';

  const [loading, setLoading] = useState(true);
  const [cardId, setCardId] = useState(null);
  const [existingUrls, setExistingUrls] = useState([]);
  const [existingStateCardId, setExistingStateCardId] = useState(null);

  useEffect(() => {
    if (SUPPORTED_STATES.includes(userState)) {
      loadExistingCard();
    } else {
      setLoading(false);
    }
  }, []);

  const loadExistingCard = async () => {
    try {
      const {
        data: { data: cards },
      } = await mmjCardService.getCards(currentUser.uid);

      if (cards && cards.length > 0) {
        const card =
          cards.find((c) => c.state && c.state.toLowerCase() === userState) ||
          cards[0];
        setCardId(card.uid);
        setExistingUrls(card.patient_document_urls || []);
        setExistingStateCardId(card.state_card_id || null);
      }
    } catch (err) {
      console.log(err);
    }
    setLoading(false);
  };

  if (!SUPPORTED_STATES.includes(userState)) return null;
  if (loading) {
    return (
      <Card>
        <LoadingOverlay show />
      </Card>
    );
  }

  return (
    <Card>
      {FILE_UPLOAD_STATES.includes(userState) && (
        <FileUpload
          state={userState}
          cardId={cardId}
          existingUrls={existingUrls}
          onCardCreated={(id) => setCardId(id)}
          onSuccess={loadExistingCard}
          patientId={currentUser.uid}
          platformId={platformId}
        />
      )}
      {TEXT_INPUT_STATES.includes(userState) && (
        <StateIdInput
          state={userState}
          cardId={cardId}
          existingValue={existingStateCardId}
          onCardCreated={(id) => setCardId(id)}
          onSuccess={loadExistingCard}
          patientId={currentUser.uid}
          platformId={platformId}
        />
      )}
    </Card>
  );
};

export default PatientDocumentUpload;
